import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=784bd48e&scoped=true&"
import script from "./Sticky.vue?vue&type=script&lang=ts&"
export * from "./Sticky.vue?vue&type=script&lang=ts&"
import style0 from "./Sticky.vue?vue&type=style&index=0&id=784bd48e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784bd48e",
  null
  
)

export default component.exports